import clarity from '@microsoft/clarity';

export const Clarity = {
  /**
   * Initializes Microsoft Clarity and sets up error tracking.
   * Should be called once at the application entry point.
   */
  init: () => {
    const projectId = 'uemxypcrqw';
    
    // The package handles initialization checks internally
    clarity.init(projectId);

    // Error tracking integration
    window.addEventListener("error", (e) => {
      // We cast to any because the typed definition might expect string, 
      // but we want to pass the object as requested.
      const errorPayload = {
        message: e.message,
        source: e.filename,
        line: e.lineno,
        column: e.colno
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      clarity.setTag("js_error", errorPayload as any);
    });
  },

  /**
   * Sets a custom tag or variable in Clarity.
   * @param key The key for the tag/variable.
   * @param value The value for the tag/variable. Can be a string or an object.
   */
  set: (key: string, value: string | object) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    clarity.setTag(key, value as any);
  }
};
